/**
 * Curated "Smart Picks" — quick-tap discovery on the landing page.
 * Each card deep-links to /browse with multiple filters preset so newcomers
 * see what AfriMarket can do in one click.
 *
 * Add or reorder freely — the landing page renders them in order.
 */
export const SMART_PICKS = [
  {
    id: "ankara-london",
    overline: "Fashion · Peckham",
    title: "Ankara dresses",
    sub: "Size M · UK · pay in £",
    accent: "#C05A3C",
    bg: "#F3EFE9",
    href: "/browse?type=product&category=Fashion+%26+Ankara&size=M&country=UK&region=Peckham&currency=GBP",
  },
  {
    id: "trainers-lagos",
    overline: "Shoes · Lagos",
    title: "Trainers, UK 7",
    sub: "Local sellers · pay in ₦, no FX",
    accent: "#1A2024",
    bg: "#FBF6EE",
    href: "/browse?type=product&category=Fashion+%26+Ankara&size=UK+7&country=Nigeria&region=Lagos&currency=NGN",
  },
  {
    id: "hair-houston",
    overline: "Beauty · Houston",
    title: 'Hair bundles 18"',
    sub: "Texas · pay in $",
    accent: "#D9923B",
    bg: "#F3EFE9",
    href: '/browse?type=product&category=Beauty+%26+Hair&size=18%22&country=USA&region=Houston&currency=USD',
  },
  {
    id: "jollof-atlanta",
    overline: "Food · Atlanta",
    title: "Jollof rice & suya",
    sub: "Local cooks · GA",
    accent: "#4A5D23",
    bg: "#FBF6EE",
    href: "/browse?type=product&category=Food+%26+Spices&country=USA&region=Atlanta&currency=USD",
  },
  {
    id: "ring-accra",
    overline: "Jewelry · Accra",
    title: "Wedding rings, size O",
    sub: "Goldsmiths · pay in ₵",
    accent: "#C05A3C",
    bg: "#F3EFE9",
    href: "/browse?type=product&category=Jewelry&size=O&country=Ghana&region=Accra&currency=GHS",
  },
  {
    id: "cleaning-manchester",
    overline: "Services · Manchester",
    title: "Home cleaning",
    sub: "Vetted local providers · £",
    accent: "#1A2024",
    bg: "#FBF6EE",
    href: "/browse?type=service&category=Home+Services&country=UK&region=Manchester&currency=GBP",
  },
  {
    id: "spices-uk",
    overline: "Spices · ships UK-wide",
    title: "Suya pepper · 500g",
    sub: "Shipped from Lagos · pay in £",
    accent: "#D9923B",
    bg: "#F3EFE9",
    href: "/browse?type=product&category=Food+%26+Spices&size=500g&country=Nigeria&currency=GBP",
  },
  {
    id: "decor-toronto",
    overline: "Home · Toronto",
    title: "Ankara cushions",
    sub: "Canadian sellers · pay in C$",
    accent: "#4A5D23",
    bg: "#FBF6EE",
    href: "/browse?type=product&category=Home+%26+Decor&size=Large&country=Canada&region=Toronto&currency=CAD",
  },
];
